import { Controller } from "@hotwired/stimulus"

// Clears all form inputs and selects without submitting
export default class extends Controller {
  clear() {
    // Clear all text/number inputs
    this.element.querySelectorAll('input[type="text"], input[type="number"]').forEach(input => {
      input.value = ''
    })

    // Reset all selects to first option (usually blank/all)
    this.element.querySelectorAll('select').forEach(select => {
      select.selectedIndex = 0
    })
  }
}
